// https://vuex.vuejs.org/en/actions.html
import axios from "axios";

export default {
  AUTH_REQUEST({ commit, dispatch }, user) {
    return new Promise((resolve, reject) => {
      const token = new Date();

      commit("AUTH_REQUEST");

      //   const baseUrl = window.location.origin.startsWith("http://localhost")
      //     ? "https://localhost:44337/"
      //     : "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/";
      const baseUrl = "https://wercbergerproductions1-kha7mhdahq-ue.a.run.app/";

      const url = baseUrl + "api/login/MessagesWebsiteLogin";

      axios
        .post(url, {
          username: user.username,
          password: user.password,
        })
        .then((resp) => {
          const response = resp.data;

          //const token = "Bearer " + response.token;

          localStorage.setItem("user-token", token);
          localStorage.setItem("user-username", user.username);
          localStorage.setItem("user-name", response.name);
          localStorage.setItem("user-phoneNumber", response.phoneNumber || "");

          commit("AUTH_SUCCESS", {
            token: token,
            user: user.username,
            name: response.name,
            phoneNumber: response.phoneNumber || "",
          });

          resolve(response);
        })
        .catch((err) => {
          commit("AUTH_ERROR", err);

          localStorage.removeItem("user-token");
          localStorage.removeItem("user-username");

          let errorMessage = err;

          if (err.response.data && err.response.data.Message) {
            errorMessage = err.response.data.Message;
          }

          reject(errorMessage);
        });
    });
  },
  AUTH_LOGOUT({ commit, dispatch }) {
    localStorage.removeItem("user-token");
    localStorage.removeItem("user-username");
    localStorage.removeItem("user-name");
    localStorage.removeItem("user-phoneNumber");

    commit("AUTH_LOGOUT");
  },
};
